import { Box, styled } from '@mui/material';

export const StyledTextContainer = styled(Box)({
  width: '100%',
  wordWrap: 'normal',
});
